import React, { useEffect, useState } from 'react'
import {
  AppBar,
  Button,
  Grid,
  Typography,
  CircularProgress
} from '@material-ui/core'
import ReactDataSheet from 'react-datasheet'
// Be sure to include styles at some point, probably during your bootstrapping
import 'react-datasheet/lib/react-datasheet.css'

export default function DataSheet (props) {
  const [data, setData] = useState([])
  const [row, setRow] = useState([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    if (props.data) {
      setData([...props.data])
      const addedRow = [
        {
          value: props.data.length,
          readOnly: true
        }
      ]
      for (const objArray of props.data) {
        for (let x = 1; x < objArray.length; x++) {
          addedRow.push({ value: '' })
        }
        break
      }
      setRow(addedRow)
    }
  }, [props.data])

  const handleAddRow = () => {
    const newRow = [...row]
    const row0 = { ...newRow[0] }
    row0.value = data.length
    newRow[0] = row0
    setData([...data, newRow])
  }
  return (
    <div style={{ position: 'relative' }}>
      <div style={data.length > 0 ? { display: 'none' } : {}}>
        <CircularProgress size={20} />{' '}
        <Typography variant='subtitle'>
          Please wait while data is loading...
        </Typography>
      </div>
      <ReactDataSheet
        data={data}
        valueRenderer={cell => cell.value}
        onCellsChanged={changes => {
          const grid = data.map(row => [...row])
          console.log(changes)
          changes.forEach(({ cell, row, col, value }) => {
            grid[row][col] = { ...grid[row][col], value }
          })
          setData(grid)
        }}
      />
      <Button
        fullWidth
        onClick={() => handleAddRow()}
        style={data.length === 0 ? { display: 'none' } : {}}
      >
        Add Row
      </Button>
      <div style={{ position: 'fixed', bottom: '1rem', right: '1rem' }}>
        <Grid container column spacing={2}>
          <Grid item>
            <Button
              onClick={() => props.save(data)}
              variant='contained'
              color='secondary'
              size='small'
              fullWidth
            >
              Save data
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant='contained'
              color='secondary'
              size='small'
              onClick={props.refresh}
            >
              Refresh data
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
